import React from 'react'
import {Row} from 'reactstrap'

const row=(props)=>(<Row {...props}/>)

export default row;